import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  ViewChild,
  forwardRef,
} from "@angular/core";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { ActionGridRow } from "../treeslo-grid.model";
import { TreesloGridActionMenuHost } from "./treeslo-grid-action-menu-host";

@Component({
  selector: "app-treeslo-grid-action-menu",
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatTooltipModule,
    TranslateModule,
    TablerIconsModule,
    forwardRef(() => TreesloGridActionMenuComponent),
  ],
  templateUrl: "./treeslo-grid-action-menu.component.html",
  styleUrls: ["./treeslo-grid-action-menu.component.scss"],
})
export class TreesloGridActionMenuComponent<ItemModel extends Record<string, any>> {
  @Input({ required: true }) actions!: ActionGridRow<ItemModel>[];
  @Input({ required: true }) row!: ItemModel;
  @Input() rowIndex?: number;
  @Input({ required: true }) host!: TreesloGridActionMenuHost<ItemModel>;

  @ViewChild("menu", { static: true }) menuRef!: MatMenu;

  get menu(): MatMenu {
    return this.menuRef;
  }

  trackAction(index: number, action: ActionGridRow<ItemModel>): string {
    return `${index}-${action.label ?? ""}-${action.icon ?? ""}`;
  }

  hasNestedMenu(action: ActionGridRow<ItemModel>): boolean {
    return !!action.dropdownMode && this.getNestedActions(action).length > 0;
  }

  getNestedActions(
    action: ActionGridRow<ItemModel>,
  ): ActionGridRow<ItemModel>[] {
    return this.host.getVisibleDropdownActions(
      action.dropdownChildrenActions ?? [],
      this.row,
    );
  }

  onLeafClick(action: ActionGridRow<ItemModel>, event: Event): void {
    this.host.executeAction(action, this.row, event, this.rowIndex);
  }
}
